export default __webpack_public_path__ + "static/media/doge.77024c56.png";